import { unreadConversations } from './inbox.state';
import { Conversation } from '@/modules/messenger/_modules/conversation/models/Conversation';

export function setUnreadConversations(conversations: Conversation[] = []): void {
  unreadConversations.value = conversations;
}

export function addUnreadConversation(conversation: Conversation): void {
  const index: number = unreadConversations.value.findIndex(
    (unreadConversation: Conversation) => unreadConversation.id === conversation.id
  );
  index > -1
    ? unreadConversations.value.splice(index, 1, conversation)
    : unreadConversations.value.push(conversation);
}

export function removeUnreadConversation(conversationId: number): void {
  unreadConversations.value = unreadConversations.value.filter(
    (conversation: Conversation) => conversation.id !== conversationId
  );
}
